export const blue = 'linear-gradient(90deg,rgba(106, 0, 241, 1) 0%,rgba(103, 0, 239, 1) 18%,rgba(88, 0, 231, 1) 35%,rgba(58, 0, 216, 1) 51%,rgba(30, 0, 202, 1) 72%,rgba(9, 0, 190, 1) 100%)';

export const blue2 = 'linear-gradient(90deg,rgba(106, 0, 241, 1) 0%,rgba(103, 0, 239, 1) 18%,rgba(88, 0, 231, 1) 35%,rgba(58, 0, 216, 1) 51%,rgba(30, 0, 202, 1) 72%,rgba(9, 0, 190, 1) 100%)';
